import React, { Fragment } from 'react';
import { ConfigurationProvider } from './Context/Configuration';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import '@progress/kendo-theme-default/dist/all.css';
import HomePage from './pages/HomePage';
import Voraxor from './pages/Voraxor'; 
import Smoulder from './pages/Smoulder';
import Certitude from './pages/Certitude';
import QA from './pages/QA';
import Contest from './pages/Contest';
import PreseedHerbicide from './pages/PreseedHerbicide';
import Content from './Components/Content/Content';
import NavBar from './Components/NavBar/NavBar';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import FooterBanner from './Components/FooterBanner/FooterBanner';
import './App.css';

function App() {	
	const coming_soon = () => {		
		return false;
		/*
		let location = window.location;
		return (location.pathname === '/vt/coming-soon' || location.host === 'agro.basf.ca')
		*/
	}

	return (
		<ConfigurationProvider>
			
					<BrowserRouter basename={'/preseedherbicide'}>
						<Header />
						<NavBar coming_soon={coming_soon()}/>
						<Content>
							<Switch>								
								<Route path="/home">
									<HomePage />
								</Route>
								<Route path="/preseedherbicide">
									<PreseedHerbicide />
								</Route>
								<Route path="/certitude">
									<Certitude />
								</Route>
								<Route path="/smoulder">
									<Smoulder />
								</Route>
								<Route path="/voraxor">
									<Voraxor />
								</Route>
								<Route path="/entercontest">
									<Redirect to="/home" />
								</Route>
								<Route path="/quiz">
									<QA />
								</Route>
								<Route path="/:pin">
									<HomePage />
								</Route>
								<Redirect to="/home" />
							</Switch>	
						</Content>
						<FooterBanner></FooterBanner>
						<Footer coming_soon={coming_soon()}></Footer>
					</BrowserRouter>
				
		</ConfigurationProvider>
	)
}

export default App;
